import React,  { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Loading from './Loading';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { postResult } from "./utils";

const Donate = (props) => {
  
  const { ReactGA, selectMenu } = props;
  const [loading, setLoading] = useState(true);  
  const [submitted, setSubmitted] = useState(false);  
  const [name, setName] = useState('');  
  const [email, setEmail] = useState('');  
  const [phone, setPhone] = useState('');  
  const [intention, setIntention] = useState('');  

  const [confirm, setConfirm] = useState(false);  
  const [ inited, setInited ] = useState(false);
  
  useEffect(() => {
    if (!inited) {
      setInited(true);
      setLoading(false);
    }    
  }, [inited, setInited]); // Or [] if effect doesn't need props or state

  function handleClick() {
    setLoading(true);
    const type = 'Revision';
    ReactGA.event({
      category: type,
      action: type,
      value: intention
    });
    return postResult({
      type,
      email,
      name,
      phone,
      intention,
    }).then(() => {
      setSubmitted(true);
      setLoading(false);
    })    
  }

  const disabled = !name || (!email && !phone) || !intention || !confirm

  return loading ? <Loading/> : (<>
    <Container>   
    <h2>Quran Revision Day</h2>
    {submitted ? <>
      Jazakallah khairun for your submitting your intentions. May Allah reward your efforts!
      <Button variant="primary" type="submit" onClick={() => selectMenu('')}>
        Return to Main Menu
      </Button>
    </>
    :<Form>
      <p>Come to the masjid and spend the day from Fajr to Isha immersed among your brothers and sisters revising the Quran. Make your intention below! Snacks and drinks to be provided throughout the day. Please fill out the form so we know how much to prepare for</p>
      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label>Enter your full name:</Form.Label>
        <Form.Control type="text" placeholder="Full name" onChange={(ev) => setName(ev.target.value)} value={name}/>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label>Enter your email address:</Form.Label>
        <Form.Control type="text" placeholder="Email address" onChange={(ev) => setEmail(ev.target.value)} value={email}/>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formPhoneNumber">
        <Form.Label>Enter your phone number (Whatsapp):</Form.Label>
        <Form.Control type="text" placeholder="Phone number"  onChange={(ev) => setPhone(ev.target.value)} value={phone}/>
      </Form.Group> 

      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label>How many juzz do you intend to revise:</Form.Label>
        <Form.Check
          key={"1"}
          type="radio"
          name="taskOptions" // same name = radio group
          id={`radio-1`}
          label={"1-5 Juzz"}
          checked={intention === "one"}
          onChange={() => setIntention("one")}
        />
        <Form.Check
          key={"5"}
          type="radio"
          name="taskOptions" // same name = radio group
          id={`radio-5`}
          label={"5 Juzz"}
          checked={intention === "five"}
          onChange={() => setIntention("five")}
        />
        <Form.Check
          key={"10"}
          type="radio"
          name="taskOptions" // same name = radio group
          id={`radio-10`}
          label={"10 Juzz"}
          checked={intention === "ten"}
          onChange={() => setIntention("ten")}
        />
        <Form.Check
          key={"15"}
          type="radio"
          name="taskOptions" // same name = radio group
          id={`radio-15`}
          label={"15+"}
          checked={intention === "fifteen"}
          onChange={() => setIntention("fifteen")}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicCheckbox">
        <Form.Check type="checkbox" onClick={() => setConfirm(!confirm)} label="I confirm that I will obey the general rules of the masjid" />
      </Form.Group>

      <Button variant="primary" type="submit" onClick={handleClick} disabled={disabled}>
        Submit
      </Button>
    </Form>}       
    </Container>
    </>
);
}

export default Donate;
